export default __webpack_public_path__ + "icon_map_alternate.846a30f4d6c2d11e6028a72e4790e258.svg";